import { useQuery } from "@tanstack/react-query";
import api from "../../services/api";


export const useViewSingleCaseStudy = (id) => {
  return useQuery({
    queryKey: ["viewCaseStudy", id],
    queryFn: async () => {
      const res = await api.get(`/case-study/${id}`);
      return res.data;
    },
    enabled: !!id,
  });
};